module.exports = __webpack_public_path__ + "static/media/Pointer_Light.85cc3cfc.svg";